import { MonoTypeOperatorFunction } from 'rxjs';
import { MyVerbale } from '../../features/revisione53/core/models/interfaces/revisione.interface';
import { filter } from 'rxjs/operators';
import { checkIdAssegnazione, checkMatricola } from '@shared/helpers/utils.helper';
import { environment } from '@env';

export function filterMatricolaVerbale(): MonoTypeOperatorFunction<MyVerbale> {
    return filter((myVerbale: MyVerbale) => {
        // Null guard is always enforced: populateForm must never run on a missing verbale.
        if (!myVerbale) {
            return false;
        }
        // In testing mode we skip the matricola/idAssegnazione match against sessionStorage,
        // so an imported XML verbale can populate the forms without going through the assignment flow.
        if (environment.testingMode) {
            return true;
        }
        return checkMatricola(myVerbale) && checkIdAssegnazione(myVerbale);
    });
}
